module.exports = "<app-control-panel></app-control-panel>\n<app-visualization></app-visualization>"